import { CirclePause, CreditCard, Mail, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trpc } from "@/lib/trpc";

export default function AccountSuspended({ paymentRequired = false }: { paymentRequired?: boolean }) {
  const checkoutMutation = trpc.billing.startCheckout.useMutation({
    onSuccess: ({ url }) => { window.location.assign(url); },
  });
  const logoutMutation = trpc.auth.logout.useMutation({
    onSuccess: () => {
      window.location.href = `/login?error=${paymentRequired ? "payment_required" : "account_suspended"}`;
    },
  });

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center">
            <CirclePause className="w-9 h-9 text-amber-700" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-foreground">
            {paymentRequired ? "Assinatura necessária" : "Acesso temporariamente suspenso"}
          </h1>
          <p className="text-muted-foreground text-sm leading-relaxed">
            {paymentRequired
              ? "O período gratuito terminou ou não há uma assinatura ativa. Seus lançamentos continuam guardados e o acesso será liberado após a regularização."
              : "Esta conta não pode usar o Bolso neste momento. Seus lançamentos continuam guardados e voltarão a aparecer quando o acesso for reativado."}
          </p>
        </div>

        <div className="bg-muted/50 border rounded-xl p-4 text-left space-y-2">
          <div className="flex items-center gap-2 text-sm font-medium">
            <Mail className="w-4 h-4 text-primary" />
            <span>{paymentRequired ? "Como assinar?" : "Como regularizar?"}</span>
          </div>
          <p className="text-sm text-muted-foreground">
            {paymentRequired
              ? "O checkout da assinatura será disponibilizado nesta tela quando o gateway de pagamento for conectado. Até lá, entre em contato com o atendimento do Bolso."
              : "Entre em contato com o atendimento do Bolso para confirmar o pagamento ou esclarecer qualquer dúvida sobre sua assinatura."}
          </p>
        </div>

        {paymentRequired && (
          <div className="space-y-2">
            <Button
              className="w-full min-h-12 text-base"
              onClick={() => checkoutMutation.mutate()}
              disabled={checkoutMutation.isPending}
            >
              <CreditCard className="w-5 h-5 mr-2" />
              {checkoutMutation.isPending ? "Abrindo pagamento..." : "Assinar por R$ 18,90/mês"}
            </Button>
            {checkoutMutation.error?.message === "PAYMENT_NOT_CONFIGURED" && (
              <p className="text-xs text-muted-foreground">O pagamento ainda está sendo configurado. Entre em contato com o atendimento.</p>
            )}
          </div>
        )}

        <Button
          variant="outline"
          className="w-full"
          onClick={() => logoutMutation.mutate()}
          disabled={logoutMutation.isPending}
        >
          <LogOut className="w-4 h-4 mr-2" />
          {logoutMutation.isPending ? "Saindo..." : "Sair da conta"}
        </Button>
      </div>
    </div>
  );
}
